import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ExportApi = createApi({
  reducerPath: "ExportApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["EXPORTAPI"],
  endpoints: (build) => ({
    // Export Rides
    exportRides: build.query({
      query: ({ format = "csv", startDate, endDate, status }) => {
        const params = new URLSearchParams();
        params.append("format", format);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (status) params.append("status", status);

        return {
          url: `/export/rides?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          responseHandler: format === "csv" 
            ? (response) => response.blob()
            : (response) => response.json(),
        };
      },
      providesTags: ["EXPORTAPI"],
    }),

    // Export Long Drives
    exportLongDrives: build.query({
      query: ({ format = "csv", startDate, endDate, status }) => {
        const params = new URLSearchParams();
        params.append("format", format);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (status) params.append("status", status);

        return {
          url: `/export/long-drives?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          responseHandler: format === "csv" 
            ? (response) => response.blob()
            : (response) => response.json(),
        };
      },
      providesTags: ["EXPORTAPI"],
    }),

    // Export Users
    exportUsers: build.query({
      query: ({ format = "csv", role, isVerified }) => {
        const params = new URLSearchParams();
        params.append("format", format);
        if (role) params.append("role", role);
        if (isVerified !== undefined) params.append("isVerified", isVerified);

        return {
          url: `/export/users?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          responseHandler: format === "csv"
            ? (response) => response.blob()
            : (response) => response.json(),
        };
      },
      providesTags: ["EXPORTAPI"],
    }),

    // Export Wallet Transactions
    exportWalletTransactions: build.query({
      query: ({ format = "csv", startDate, endDate, type, category }) => {
        const params = new URLSearchParams();
        params.append("format", format);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (type) params.append("type", type);
        if (category) params.append("category", category);

        return {
          url: `/export/wallet-transactions?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          responseHandler: format === "csv" 
            ? (response) => response.blob()
            : (response) => response.json(),
        };
      },
      providesTags: ["EXPORTAPI"],
    }),

    // Export Financial Summary
    exportFinancialSummary: build.query({
      query: ({ format = "csv", startDate, endDate }) => {
        const params = new URLSearchParams();
        params.append("format", format);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        return {
          url: `/export/financial-summary?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          responseHandler: format === "csv" 
            ? (response) => response.blob()
            : (response) => response.json(),
        };
      },
      providesTags: ["EXPORTAPI"],
    }),

    // Export All Data
    exportAllData: build.query({
      query: ({ startDate, endDate }) => {
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        return {
          url: `/export/all?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["EXPORTAPI"],
    }),
  }),
});

export const {
  useLazyExportRidesQuery,
  useLazyExportLongDrivesQuery,
  useLazyExportUsersQuery,
  useLazyExportWalletTransactionsQuery,
  useLazyExportFinancialSummaryQuery,
  useLazyExportAllDataQuery,
} = ExportApi;